import { MenuConstants } from './';

const initialState = { menuCollapsed: false };

export function MenuReducer(state = initialState, action) {
  switch (action.type) {
    case MenuConstants.MENU_TOGGLE:
      return {
        ...state,
        menuCollapsed: !state.menuCollapsed,
      };
    case MenuConstants.SET_CONTENT_MENU:
      return {
        ...state,
        contentMenu: action.payload.contentMenu,
        contentMenuPath: action.payload.path,
      };
    case MenuConstants.SET_TITLE:
      return {
        ...state,
        contentTitle: action.payload.title,
      };
    default:
      return state;
  }
}
